import React from 'react';
import { AlertCircle, HelpCircle, User } from 'lucide-react';
import { motion } from 'framer-motion';
const hooks = [{
  type: 'Gancho Negativo',
  text: 'Lo que tu banco no quiere que sepas...',
  icon: AlertCircle,
  gradient: 'from-red-900/20 to-[#0a1628]'
}, {
  type: 'Gancho de Curiosidad',
  text: 'La razón por la que siempre estás cansada...',
  icon: HelpCircle,
  gradient: 'from-amber-900/20 to-[#0a1628]'
}, {
  type: 'Gancho de Identidad',
  text: 'Si eres mujer en México y trabajas más de 8 horas...',
  icon: User,
  gradient: 'from-blue-900/20 to-[#0a1628]'
}];
export function HookExamples() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-136">
      {hooks.map((hook, index) => <motion.div key={index} initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.2,
      duration: 0.5
    }} className={`relative p-8 rounded-2xl bg-gradient-to-br ${hook.gradient} border border-[#d4a843]/20 overflow-hidden group`} data-id="element-137">
          <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-138">
            <hook.icon className="w-24 h-24 text-[#d4a843]" data-id="element-139" />
          </div>

          <div className="relative z-10" data-id="element-140">
            <div className="inline-flex items-center space-x-2 mb-4" data-id="element-141">
              <hook.icon className="w-5 h-5 text-[#d4a843]" data-id="element-142" />
              <span className="text-sm font-bold text-[#d4a843] uppercase tracking-wider" data-id="element-143">
                {hook.type}
              </span>
            </div>

            <blockquote className="text-2xl font-serif text-white leading-snug italic" data-id="element-144">
              "{hook.text}"
            </blockquote>
          </div>
        </motion.div>)}
    </div>;
}